import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix pentru icon Leaflet
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
});

const counties = [
  'Alba', 'Arad', 'Arges', 'Bacau', 'Bihor', 'Bistrita-Nasaud', 'Botosani',
  'Brasov', 'Braila', 'Buzau', 'Caras-Severin', 'Calarasi', 'Cluj',
  'Constanta', 'Covasna', 'Dambovita', 'Dolj', 'Galati', 'Giurgiu', 'Gorj',
  'Harghita', 'Hunedoara', 'Ialomita', 'Iasi', 'Ilfov', 'Maramures', 'Mehedinti',
  'Mures', 'Neamt', 'Olt', 'Prahova', 'Satu Mare', 'Salaj', 'Sibiu', 'Suceava',
  'Teleorman', 'Timis', 'Tulcea', 'Vaslui', 'Valcea', 'Vrancea'
];

const countyToRegion = {
  'Alba': 'Transilvania', 'Arad': 'Crisana', 'Arges': 'Muntenia', 'Bacau': 'Moldova',
  'Bihor': 'Crisana', 'Bistrita-Nasaud': 'Transilvania', 'Botosani': 'Moldova',
  'Brasov': 'Transilvania', 'Braila': 'Muntenia', 'Buzau': 'Muntenia',
  'Caras-Severin': 'Banat', 'Calarasi': 'Muntenia', 'Cluj': 'Transilvania',
  'Constanta': 'Dobrogea', 'Covasna': 'Transilvania', 'Dambovita': 'Muntenia',
  'Dolj': 'Oltenia', 'Galati': 'Moldova', 'Giurgiu': 'Muntenia', 'Gorj': 'Oltenia',
  'Harghita': 'Transilvania', 'Hunedoara': 'Transilvania', 'Ialomita': 'Muntenia',
  'Iasi': 'Moldova', 'Ilfov': 'Muntenia', 'Maramures': 'Maramures', 'Mehedinti': 'Oltenia',
  'Mures': 'Transilvania', 'Neamt': 'Moldova', 'Olt': 'Oltenia', 'Prahova': 'Muntenia',
  'Satu Mare': 'Crisana', 'Salaj': 'Crisana', 'Sibiu': 'Transilvania', 'Suceava': 'Bucovina',
  'Teleorman': 'Muntenia', 'Timis': 'Banat', 'Tulcea': 'Dobrogea', 'Vaslui': 'Moldova',
  'Valcea': 'Oltenia', 'Vrancea': 'Moldova'
};

function RecenterMap({ lat, lng }) {
  const map = useMap();

  useEffect(() => {
    if (lat !== undefined && lng !== undefined) {
      map.setView([lat, lng]);
    }
  }, [lat, lng, map]);

  return null;
}

export default function PropertyInfo({
  phone = '',
  email = '',
  address = '',
  county = '',
  locality = '',
  lat = 0,
  lng = 0,
  reviews,
  userRole,
  editMode = false,
  onChange
}) {
  const [region, setRegion] = useState('');
  const [mapLat, setMapLat] = useState(lat || 46.0);
  const [mapLng, setMapLng] = useState(lng || 25.0);

  useEffect(() => {
    if (!editMode && lat && lng) {
      setMapLat(lat);
      setMapLng(lng);
    }
  }, [lat, lng, editMode]);

  const editable = userRole === 'host' && editMode;

  // 🔹 Forward geocoding
  const geocodeLocation = async (loc, cty, addr) => {
    if (!loc && !cty && !addr) return;

    try {
      const query = [loc, addr, cty].filter(Boolean).join(', ');

      const res = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}`
      );

      const data = await res.json();

      if (data.length > 0) {
        const { lat, lon } = data[0];

        setMapLat(Number(lat));
        setMapLng(Number(lon));

        onChange({ target: { name: 'lat', value: Number(lat) } });
        onChange({ target: { name: 'lng', value: Number(lon) } });
      }
    } catch (err) {
      console.error('Geocoding error:', err);
    }
  };

  useEffect(() => {
    setRegion(county ? countyToRegion[county] : '');

    const timeout = setTimeout(() => {
      if (locality || county || address) {
        geocodeLocation(locality, county, address);
      }
    }, 400);

    return () => clearTimeout(timeout);

  }, [locality, county, address, editable]);

  // 🔹 Reverse geocoding
  const reverseGeocode = async (lat, lng) => {
    try {
      const res = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`);
      const data = await res.json();
      if (data.address) {
        if (editable) {
          onChange({ target: { name: 'address', value: data.address.road || '' } });
          onChange({ target: { name: 'locality', value: data.address.city || data.address.town || '' } });
          onChange({ target: { name: 'county', value: data.address.county || '' } });
        }
      }
    } catch (err) {
      console.error('Reverse geocoding error:', err);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    onChange(e);
  };

  return (
    <div>

      <h3 style={{ color: '#0C5678', marginBottom: '0.75rem' }}>
        Contact & Locatie
      </h3>

      <div className="info-grid">

        {/* JUDET */}
        <div className="info-row">
          <span className="info-label">Judet</span>

          {editable ? (
            <select
              name="county"
              value={county}
              onChange={handleInputChange}
              className="info-input"
            >
              <option value="">Judet</option>
              {counties.map(c => (
                <option key={c} value={c}>{c}</option>
              ))}
            </select>
          ) : (
            <span className="info-value">{county || 'N/A'}</span>
          )}
        </div>

        {/* LOCALITATE */}
        <div className="info-row">
          <span className="info-label">Localitate</span>

          {editable ? (
            <input
              name="locality"
              value={locality}
              onChange={handleInputChange}
              placeholder="Localitate"
              className="info-input"
            />
          ) : (
            <span className="info-value">{locality || 'N/A'}</span>
          )}
        </div>

        {/* STRADA */}
        <div className="info-row">
          <span className="info-label">Strada</span>

          {editable ? (
            <input
              name="address"
              value={address}
              onChange={handleInputChange}
              placeholder="Strada"
              className="info-input"
            />
          ) : (
            <span className="info-value">{address || 'N/A'}</span>
          )}
        </div>

        {/* TELEFON */}
        <div className="info-row">
          <span className="info-label">Telefon</span>

          {editable ? (
            <input
              name="phone"
              value={phone}
              onChange={handleInputChange}
              placeholder="Telefon"
              className="info-input"
            />
          ) : (
            <span className="info-value">{phone || 'N/A'}</span>
          )}
        </div>

        {/* EMAIL */}
        <div className="info-row">
          <span className="info-label">Email</span>

          {editable ? (
            <input
              name="email"
              value={email}
              onChange={handleInputChange}
              placeholder="Email"
              className="info-input"
            />
          ) : (
            <span className="info-value">{email || 'N/A'}</span>
          )}
        </div>

        {/* REGIUNE */}
        <div className="info-row">
          <span className="info-label">Regiune</span>
          <span className="info-value info-badge">
            {region || 'N/A'}
          </span>
        </div>

      </div>

      {/* HARTA */}
      <h3>Harta</h3>

      {county && locality ? (
        <MapContainer
          center={[mapLat || 46, mapLng || 25]}
          zoom={13}
          style={{ height: '300px', width: '100%' }}
        >
          <RecenterMap lat={mapLat} lng={mapLng} />
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <Marker
            position={[mapLat, mapLng]}
            draggable={editable}
            eventHandlers={{
              dragend: (e) => {
                const marker = e.target;
                const position = marker.getLatLng();

                setMapLat(position.lat);
                setMapLng(position.lng);

                reverseGeocode(position.lat, position.lng);

                onChange({ target: { name: 'lat', value: position.lat } });
                onChange({ target: { name: 'lng', value: position.lng } });
              }
            }}
          >
            <Popup>Locatia ta</Popup>
          </Marker>
        </MapContainer>
      ) : (
        <div style={{
          height: '200px',
          background: '#f0f0f0',
          borderRadius: '6px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          Fara harta
        </div>
      )}

    </div>
  );
}